// extracted by mini-css-extract-plugin
module.exports = {"container":"JwtTokenDebugView_container__2qEeG","text":"JwtTokenDebugView_text__BshQX"};